import { useEffect } from 'react';

import { useCreateSetupIntentMutation } from './graphql/SetupIntent.generated';

export function useSetupIntent(pause = false) {
  const [response, refetchSetupIntent] = useCreateSetupIntentMutation();

  useEffect(() => {
    if (pause) return;
    void refetchSetupIntent({});
  }, [pause, refetchSetupIntent]);

  const setupIntentSecret = response?.data?.createPaymentIntent;
  const isFetchingSetupIntent = response.fetching;

  return {
    setupIntentSecret,
    isFetchingSetupIntent,
    refetchSetupIntent,
  };
}
